import { api } from "@/api/client";
import type {
  MpBuyoutCreateRequest,
  MpBuyoutCreateResponse,
  MpBuyoutListItem,
  MpBuyoutPreviewResponse,
  MpBuyoutUploadResponse,
} from "@/types/api";

export async function listMpBuyouts(): Promise<MpBuyoutListItem[]> {
  const { data } = await api.get<MpBuyoutListItem[]>("/marketplace-buyouts");
  return data;
}

export async function uploadMpBuyout(args: {
  file: File;
  mp_code: string;
  organization_key: string;
  organization_name: string;
}): Promise<MpBuyoutUploadResponse> {
  const form = new FormData();
  form.append("file", args.file);
  form.append("mp_code", args.mp_code);
  form.append("organization_key", args.organization_key);
  form.append("organization_name", args.organization_name);
  const { data } = await api.post<MpBuyoutUploadResponse>(
    "/marketplace-buyouts/upload",
    form,
  );
  return data;
}

export async function getMpBuyoutPreview(
  id: string,
  opts?: { unfConnectionId?: string; bpConnectionId?: string },
): Promise<MpBuyoutPreviewResponse> {
  const params: Record<string, string> = {};
  if (opts?.unfConnectionId) params.unf_connection_id = opts.unfConnectionId;
  if (opts?.bpConnectionId) params.bp_connection_id = opts.bpConnectionId;
  const { data } = await api.get<MpBuyoutPreviewResponse>(
    `/marketplace-buyouts/${id}/preview`,
    { params },
  );
  return data;
}

export async function createMpBuyoutInUnf(
  id: string,
  body: MpBuyoutCreateRequest,
): Promise<MpBuyoutCreateResponse> {
  const { data } = await api.post<MpBuyoutCreateResponse>(
    `/marketplace-buyouts/${id}/create-in-1c/unf`,
    body,
  );
  return data;
}

export async function createMpBuyoutInBp(
  id: string,
  body: MpBuyoutCreateRequest,
): Promise<MpBuyoutCreateResponse> {
  const { data } = await api.post<MpBuyoutCreateResponse>(
    `/marketplace-buyouts/${id}/create-in-1c/bp`,
    body,
  );
  return data;
}

export async function deleteMpBuyout(id: string): Promise<void> {
  await api.delete(`/marketplace-buyouts/${id}`);
}
